export default {
  'pages.system.menu.title': '選單管理',
  'pages.system.menu.name': '選單名稱',
  'pages.system.menu.path': '路徑',
  'pages.system.menu.icon': '圖示',
  'pages.system.menu.order': '排序',
  'pages.system.menu.enabled': '是否啟用',
  'pages.system.menu.add': '新增選單',
  'pages.system.menu.edit': '編輯選單',
  'pages.system.menu.delete': '刪除',
  'pages.system.menu.confirm': '確認刪除',
  'pages.system.menu.confirmContent': '確定要刪除此選單嗎？',
  'pages.system.menu.deleteSuccess': '刪除成功',
  'pages.system.menu.updateSuccess': '更新成功',
  'pages.system.menu.addSuccess': '新增成功',
  'pages.system.menu.namePlaceholder': '請輸入選單名稱',
  'pages.system.menu.pathPlaceholder': '請輸入路徑',
  'pages.system.menu.iconPlaceholder': '請輸入圖示名稱',
  'pages.system.menu.orderPlaceholder': '請輸入排序號',
  'pages.system.menu.nameRequired': '請輸入選單名稱',
  'pages.system.menu.pathRequired': '請輸入路徑',
  'pages.system.menu.iconRequired': '請輸入圖示',
  'pages.system.menu.orderRequired': '請輸入排序號',
  'pages.system.menu.enable': '啟用',
  'pages.system.menu.disable': '停用',
  'pages.system.menu.cancel': '取消',
  'pages.system.menu.submit': '提交',
  'pages.system.user.title': '使用者管理',
  'pages.system.user.username': '使用者名稱',
  'pages.system.user.email': '信箱',
  'pages.system.user.phone': '電話',
  'pages.system.user.role': '角色',
  'pages.system.user.status': '狀態',
  'pages.system.user.add': '新增使用者',
  'pages.system.user.edit': '編輯使用者',
  'pages.system.user.delete': '刪除',
  'pages.system.user.confirm': '確認刪除',
  'pages.system.user.confirmContent': '確定要刪除此使用者嗎？',
  'pages.system.user.deleteSuccess': '刪除成功',
  'pages.system.user.updateSuccess': '更新成功',
  'pages.system.user.addSuccess': '新增成功',
  'pages.system.user.usernamePlaceholder': '請輸入使用者名稱',
  'pages.system.user.emailPlaceholder': '請輸入信箱',
  'pages.system.user.phonePlaceholder': '請輸入電話',
  'pages.system.user.usernameRequired': '請輸入使用者名稱',
  'pages.system.user.emailRequired': '請輸入信箱',
  'pages.system.user.emailInvalid': '信箱格式不正確',
  'pages.system.user.phoneRequired': '請輸入電話',
  'pages.system.user.roleRequired': '請選擇角色',
  'pages.system.user.statusRequired': '請選擇狀態',
  'pages.system.user.admin': '管理員',
  'pages.system.user.normalUser': '一般使用者',
  'pages.system.user.enable': '啟用',
  'pages.system.user.disable': '停用',
  'pages.system.user.cancel': '取消',
  'pages.system.user.submit': '提交',
  'pages.system.role.title': '角色管理',
  'pages.system.role.name': '角色名稱',
  'pages.system.role.description': '描述',
  'pages.system.role.permissions': '權限數',
  'pages.system.role.add': '新增角色',
  'pages.system.role.edit': '編輯角色',
  'pages.system.role.delete': '刪除',
  'pages.system.role.confirm': '確認刪除',
  'pages.system.role.confirmContent': '確定要刪除此角色嗎？',
  'pages.system.role.deleteSuccess': '刪除成功',
  'pages.system.role.updateSuccess': '更新成功',
  'pages.system.role.addSuccess': '新增成功',
  'pages.system.role.namePlaceholder': '請輸入角色名稱',
  'pages.system.role.descriptionPlaceholder': '請輸入描述',
  'pages.system.role.nameRequired': '請輸入角色名稱',
  'pages.system.role.descriptionRequired': '請輸入描述',
  'pages.system.role.permissionsRequired': '請至少選擇一項權限',
  'pages.system.role.permissionConfig': '權限設定',
  'pages.system.role.cancel': '取消',
  'pages.system.role.submit': '提交',
};
